import React from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // ✅ React-Bootstrap CSS
import "./App.css";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import { RootNavigation } from "./routes";

function App() {
  return (
    <div className="">
      <BrowserRouter basename="/">
        <Toaster position="top-right" reverseOrder={false} />
        <RootNavigation />
      </BrowserRouter>
    </div>
  );
}

export default App;
